import getField from '@form/formGenerator'

export const userRoleSaveUrl = `${import.meta.env.VITE_API_URL}/api/user-roles`

export const userRoleFormObject = {
  id: null,
  role: null,
  isActive: false
}

export const userRoleFormFields = (userRoleFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'role',
      label: t('labels.role'),
      value: userRoleFormObject.role,
      key: 'userRoleFormObject-role',
      cssClass: 'column is-12'
    },
    {
      type: 'number',
      name: 'superposition',
      label: t('labels.superposition'),
      help: t('labels.help_superposition'),
      value: userRoleFormObject.superposition,
      key: 'userRoleFormObject-superposition',
      cssClass: 'column is-12'
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: userRoleFormObject.isActive,
      cssClass: 'column is-12',
      key: 'userRoleFormObject-isActive',
      id: 'userRoleFormObject-isActive'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'userRoleFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(userRoleFormObject.id),
      key: 'userRoleFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}